var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal_content" }, [
      _c("div", { staticClass: "modal_header" }, [
        _c("h5", [
          _vm._v(_vm._s(_vm.$t("sdl.approval.label.delegateApproval")))
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_body" }, [
        _vm.curDelegatorUser.delegatorId
          ? _c("div", { staticClass: "mb-4 alert alert-info" }, [
              _c("h6", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("sdl.approval.label.delegateApprovalUser"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn ui--btn-icon-sm close",
                    attrs: {
                      title: _vm.$t(
                        "sdl.approval.label.delDelegateApprovalUser"
                      )
                    },
                    on: { click: _vm.onBeforeDelete }
                  },
                  [
                    _c("i", { staticClass: "material-icons material-xs" }, [
                      _vm._v("clear")
                    ])
                  ]
                )
              ]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.curDelegatorUser.delegatorName) +
                  "/" +
                  _vm._s(_vm.curDelegatorUser.delegatorPositionName) +
                  "/" +
                  _vm._s(_vm.curDelegatorUser.delegatorDeptName) +
                  "/" +
                  _vm._s(_vm.curDelegatorUser.delegatorCompanyName)
              ),
              _c("br"),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("sdl.common.label.period")) +
                  " : " +
                  _vm._s(_vm._f("dateFormat")(_vm.curDelegatorUser.startDate)) +
                  " ~\n        " +
                  _vm._s(_vm._f("dateFormat")(_vm.curDelegatorUser.endDate)) +
                  "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h5", { staticClass: "mb-3" }, [
          _vm._v(_vm._s(_vm.$t("sdl.approval.label.addDelegateApprovalUser")))
        ]),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "table table-bordered ui--table-form ui--table-form-view"
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c(
                  "th",
                  { staticClass: "text-nowrap", attrs: { scope: "row" } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("sdl.approval.label.approver"))
                    ),
                    _c("span", { staticClass: "required" }, [_vm._v("*")])
                  ]
                ),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "input-group input-date-in" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.delegatorUser.userName,
                          expression: "delegatorUser.userName"
                        },
                        { name: "validation", rawName: "v-validation" }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("sdl.user.label.userName"),
                        errorMessage: "sdl.samsung.validate.required"
                      },
                      domProps: { value: _vm.delegatorUser.userName },
                      on: {
                        keyup: [
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape"
                              ])
                            ) {
                              return null
                            }
                            _vm.delegatorUser.userName = ""
                          },
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.openSearchUser.apply(null, arguments)
                          }
                        ],
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.delegatorUser,
                            "userName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.openSearchUser }
                        },
                        [_c("em", { staticClass: "icon-magnifier" })]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "th",
                  { staticClass: "text-nowrap", attrs: { scope: "row" } },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("sdl.common.label.period"))
                    ),
                    _c("span", { staticClass: "required" }, [_vm._v("*")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("sdl-datepicker", {
                      attrs: {
                        period: _vm.searchPeriod,
                        "wrap-class": "input-date-in"
                      },
                      model: {
                        value: _vm.searchPeriod,
                        callback: function($$v) {
                          _vm.searchPeriod = $$v
                        },
                        expression: "searchPeriod"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.cancel")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.delegateApproval }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.save")) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "30%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "70%" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13acfdfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13acfdfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup/EntrustApprovalPopup.vue
// module id = null
// module chunks = 